import Api from '../Api';

/**
 * Deletes all messages for a Sunshine Conversations conversation.
 * Backend should proxy to:
 * DELETE /v2/apps/{appId}/conversations/{conversationId}/messages
 *
 * @see https://docs.smooch.io/guide/clearing-conversations/
 */
class ZendeskServices extends Api {
  async authenticateMessenger() {
    return this.httpClient.get('/authenticateMessenger');
  }

  async clearConversationMessages(conversationId: string) {
    return this.httpClient.delete(`/conversations/${conversationId}/messages`);
  }
}
export { ZendeskServices };
